import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext'
import {usePlayerValidators} from './usePlayerValidators'
import {MechanicValidatorProgressCards} from '@colonist/game-mechanic-validators'
import {useMapValidator} from './useMapValidator'

export const useMechanicValidatorProgressCards = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const mechanicProgressCardsState = useGameStore((state) => state.gameState.mechanicProgressCardsState)

    return useMemo(() => {
        if(!mechanicProgressCardsState) return undefined
        return new MechanicValidatorProgressCards(playerValidators, mapValidator, mechanicProgressCardsState)
    }, [playerValidators, mapValidator, mechanicProgressCardsState])
}
